module.exports = __webpack_public_path__ + "img/CM-MS-24-Buick-Lifestyle.2111d001.jpg";